import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M3.19145 3.19231C3.28524 3.09858 3.40525 3.0355 3.53564 3.01139C3.66603 2.98728 3.80066 3.00327 3.92177 3.05726L20.6105 10.4746C20.7272 10.5264 20.8262 10.6112 20.8954 10.7185C20.9646 10.8259 21.001 10.9511 21 11.0788C20.999 11.2065 20.9608 11.3311 20.8899 11.4374C20.8191 11.5436 20.7188 11.6269 20.6013 11.6769L14.3522 14.3531L11.6748 20.6035C11.6244 20.7205 11.5411 20.8204 11.4349 20.8908C11.3287 20.9612 11.2042 20.9992 11.0768 21C10.9494 21.0008 10.8245 20.9645 10.7174 20.8955C10.6103 20.8264 10.5256 20.7277 10.4737 20.6113L3.0564 3.92264C3.0027 3.80169 2.98686 3.66732 3.01097 3.5372C3.03507 3.40709 3.09799 3.286 3.19145 3.19231Z' />
        </SvgIcon>
    );
});
